import React, { useEffect, useRef, useState } from "react";
import { Box, Heading, Text, Button, Layer, ResponsiveContext } from "grommet";
import { LinkPrevious, MailOption, PlayFill, Close } from "grommet-icons";
import { useNavigate } from "react-router-dom";
import { StickyFooter } from "../components/Footers/GlobalFooter";
import { HeaderNavigation } from "../components/Headers/GlobalHeader";

const ContactUser = () => {
  const navigate = useNavigate();

  // Video modal state
  const [showVideo, setShowVideo] = useState(false);
  const videoRef = useRef(null);

  // Force reload when opened
  useEffect(() => {
    if (showVideo && videoRef.current) {
      videoRef.current.load();
    }
  }, [showVideo]);

  // Your single tutorial data
  const tutorial = {
    title: "HPE Digital Skill Advisor Tutorial",
    videoUrl:
      "https://sgalitestoragepublic.blob.core.windows.net/videos/HPE%20Skill%20Advisor%20Tutorial.mp4",
  };

  return (
    <Box fill="vertical" justify="between">
      <Box flex>
        <HeaderNavigation />
        <Box>
          <Box
            direction="row"
            align="center"
            gap="small"
            margin={{ vertical: "xsmall", left: "small" }}
          >
            <Button
              icon={<LinkPrevious />}
              onClick={() => navigate(-1)}
              color="brand"
              size="large"
            />
            <Heading level="2" margin="none" textAlign="center">
              Self guided help
            </Heading>
          </Box>
        </Box>

        {/* Main Content */}
        <Box pad="large" align="center" gap="medium">
          {/* ——— Single Video Tutorial Link ——— */}
          <Box
            width="large"
            pad="medium"
            background="light-1"
            round="small"
            elevation="small"
            onClick={() => setShowVideo(true)}
            hoverIndicator
            style={{ cursor: "pointer" }}
          >
            <Box direction="row" align="center" gap="small">
              <PlayFill color="brand" />
              <Text weight="bold">{tutorial.title}</Text>
            </Box>
          </Box>

          {/* Video Modal */}
          {showVideo && (
            <Layer
              onEsc={() => setShowVideo(false)}
              onClickOutside={() => setShowVideo(false)}
              responsive
              modal
            >
              <Box pad="medium" width="large" background="white" round="small">
                <Box direction="row" justify="between" align="center">
                  <Text size="large" weight="bold">
                    Watch Video – {tutorial.title}
                  </Text>
                  <Close
                    onClick={() => setShowVideo(false)}
                    style={{ cursor: "pointer" }}
                  />
                </Box>
                <Box margin={{ top: "medium" }} align="center">
                  <video
                    key={tutorial.videoUrl}
                    ref={videoRef}
                    width="100%"
                    height="315"
                    controls
                    autoPlay
                    muted
                    playsInline
                  >
                    <source src={tutorial.videoUrl} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </Box>
              </Box>
            </Layer>
          )}

          {/* ——— Contact Support Section ——— */}
          <Box
            width="large"
            pad="medium"
            background="light-2"
            round="small"
            elevation="small"
          >
            <Heading level={2} margin="none" textAlign="center">
              Contact Us
            </Heading>
            <Text textAlign="center" size="large" margin={{ top: "small" }}>
              Need help with <strong>HPE Digital Skill Advisor</strong>? Get in touch with
              us for support.
            </Text>

            <Box align="center" margin={{ top: "medium" }}>
              <Button
                label="Email Support"
                icon={<MailOption />}
                href="mailto:hpe.skilladvisor@meteoros.in?subject=Support%20needed%20for%20HPE%20Digital%20Skill%20Advisor&body=Hi,%0A%0APlease%20provide%20details%20of%20the%20issue%20you%20are%20facing%20with%20HPE%20Digital%20Skill%20Advisor%20in%20this%20email.%20We%20will%20review%20your%20request,%20and%20get%20back%20to%20you%20within%2048%20hours.%0A%0AIf%20you%20have%20any%20screenshots%20or%20media%20content%20to%20highlight%20your%20issue,%20please%20attach%20it%20to%20this%20email.%0A%0ABest%20Wishes,%0AHPE%20Digital%20Skill%20Advisor"
                primary
              />
            </Box>
          </Box>
        </Box>
      </Box>

      {/* Sticky Footer */}
      <StickyFooter />
    </Box>
  );
};

export default ContactUser;
